export default "__VITE_ASSET__6b72af41__"